/* globals jQuery */
//https://swiperjs.com/
import Swiper, {Navigation, Pagination, EffectFade, Scrollbar, A11y,} from 'swiper';

Swiper.use([Navigation,Pagination,EffectFade,Scrollbar, A11y]);

(($) => {

    //TESTIMONIAL SLIDESHOW
	const testimonialSwiper = new Swiper('.js-testimonial-slideshow', {
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			hideOnclick: false,
			clickable: true
		}
    });

    // var comparisonSlider = new Swiper(".comparison-slider .swiper", {
    //     slidesPerView: 3,
    //     freeMode: true,
    //     spaceBetween: 170,
    //     centerInsufficientSlides: true,
    //     mousewheel: true,
    //     // breakpoints: {
    //     //     600 : { spaceBetween: 40 },
    //     //     1000 : { spaceBetween : 60 }
    //     // }
    // });
    

})(jQuery)